import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from './interceptor';

// POST: /data/buy-data-card/
export const useBuyDataCard = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/data/buy-data-card/`, data).then(res => res.data),
    });

// POST: /data/buy-data/
export const useBuyData = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/data/buy-data/`, data).then(res => res.data),
    });

// GET: /data/data-plan/{id}/
export const useDataPlanDetails = (id: string | number) =>
    useQuery({
        queryKey: ["data_data-plan_read", id],
        queryFn: () => api.get(`/data/data-plan/${id}/`).then(res => res.data),
        enabled: !!id,
    });

// GET: /data/datacardplans/
export const useDataCardPlans = () =>
    useQuery({
        queryKey: ["data_datacardplans_list"],
        queryFn: () => api.get(`/data/datacardplans/`).then(res => res.data),
    });

// POST: /data/datacardplans/
export const useCreateDataCardPlan = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/data/datacardplans/`, data).then(res => res.data),
    });

// PUT: /data/datacardplans/
export const useUpdateDataCardPlan = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.put(`/data/datacardplans/`, data).then(res => res.data),
    });

// DELETE: /data/datacardplans/
export const useDeleteDataCardPlan = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.delete(`/data/datacardplans/`, { data }).then(res => res.data),
    });

// GET: /data/network-data-card-plan/{network_id}/
export const useNetworkDataCardPlan = (network_id: string | number) =>
    useQuery({
        queryKey: ["data_network-data-card-plan_read", network_id],
        queryFn: () => api.get(`/data/network-data-card-plan/${network_id}/`).then(res => res.data),
        enabled: !!network_id,
    });

// POST: /data/network-data-card-plan/{network_id}/
export const useCreateNetworkDataCardPlan = () =>
    useMutation({
        mutationFn: ({ network_id, data }: { network_id: string | number, data: Record<string, any> }) =>
            api.post(`/data/network-data-card-plan/${network_id}/`, data).then(res => res.data),
    });

// PUT: /data/network-data-card-plan/{network_id}/
export const useUpdateNetworkDataCardPlan = () =>
    useMutation({
        mutationFn: ({ network_id, data }: { network_id: string | number, data: Record<string, any> }) =>
            api.put(`/data/network-data-card-plan/${network_id}/`, data).then(res => res.data),
    });

// DELETE: /data/network-data-card-plan/{network_id}/
export const useDeleteNetworkDataCardPlan = () =>
    useMutation({
        mutationFn: (network_id: string | number) =>
            api.delete(`/data/network-data-card-plan/${network_id}/`).then(res => res.data),
    });

// GET: /data/network-data-plan/{network}/
export const useNetworkDataPlan = (network: string | number) =>
    useQuery({
        queryKey: ["data_network-data-plan_read", network],
        queryFn: () => api.get(`/data/network-data-plan/${network}/`).then(res => res.data),
        enabled: !!network,
    });

// GET: /data/plan-types/
export const usePlanTypesList = () =>
    useQuery({
        queryKey: ["data_plan-types_list"],
        queryFn: () => api.get(`/data/plan-types/`).then(res => res.data),
    });

// POST: /data/plan-types/
export const useCreatePlanType = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/data/plan-types/`, data).then(res => res.data),
    });

// PUT: /data/plan-types/
export const useUpdatePlanTypes = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.put(`/data/plan-types/`, data).then(res => res.data),
    });

// DELETE: /data/plan-types/
export const useDeletePlanTypes = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.delete(`/data/plan-types/`, { data }).then(res => res.data),
    });

// GET: /data/plan-types/{id}/
export const usePlanTypeDetails = (id: string | number) =>
    useQuery({
        queryKey: ["data_plan-types_read", id],
        queryFn: () => api.get(`/data/plan-types/${id}/`).then(res => res.data),
        enabled: !!id,
    });

// POST: /data/plan-types/{id}/
export const useCreatePlanTypeWithId = () =>
    useMutation({
        mutationFn: ({ id, data }: { id: string | number, data: Record<string, any> }) =>
            api.post(`/data/plan-types/${id}/`, data).then(res => res.data),
    });

// PUT: /data/plan-types/{id}/
export const useUpdatePlanType = () =>
    useMutation({
        mutationFn: ({ id, data }: { id: string | number, data: Record<string, any> }) =>
            api.put(`/data/plan-types/${id}/`, data).then(res => res.data),
    });

// DELETE: /data/plan-types/{id}/
export const useDeletePlanType = () =>
    useMutation({
        mutationFn: (id: string | number) =>
            api.delete(`/data/plan-types/${id}/`).then(res => res.data),
    });
